export default "__VITE_ASSET__lyzL64Qt__"